
import { Component } from '@niknevis/vue-modules'
import AdminDepositBankAccountBaseForm
  from '@/modules/deposit-bank-account/components/admin/base/AdminDepositBankAccountBaseForm.vue'
import {
  AdminStoreDepositBankAccountUseCase
} from '@/modules/deposit-bank-account/use-cases/admin/admin-store-deposit-bank-account.use-case'

@Component
export default class AdminDepositBankAccountCreateForm extends AdminDepositBankAccountBaseForm {
  constructor(
    private readonly useCase: AdminStoreDepositBankAccountUseCase
  ) {
    super()
  }

  protected onSubmit() {
    this.useCase.execute(this.requestData)
      .onSuccess(() => {
        this.$emit('success')
      })
  }
}
